import {
  EMAIL_EMPRESARIAL_UUIDS,
  REGISTRY_DOMAIN_PRODUCT_UUIDS,
  REGISTRY_DOMAIN_UUIDS,
} from '../../shared/constants/variation-uuids.constant';

function normalizeUuid(uuid: string | null | undefined): string {
  return String(uuid ?? '').trim().toLowerCase();
}

function isUuidInList(uuid: string | null | undefined, list: readonly string[]): boolean {
  const normalized = normalizeUuid(uuid);
  if (!normalized) return false;
  return list.some((entry) => normalizeUuid(entry) === normalized);
}

export function isEmailEmpresarialVariationUuid(uuid: string | null | undefined): boolean {
  return isUuidInList(uuid, EMAIL_EMPRESARIAL_UUIDS);
}

export function isRegistryDomainVariationUuid(uuid: string | null | undefined): boolean {
  return isUuidInList(uuid, REGISTRY_DOMAIN_UUIDS);
}

export function isRegistryDomainProductUuid(uuid: string | null | undefined): boolean {
  return isUuidInList(uuid, REGISTRY_DOMAIN_PRODUCT_UUIDS);
}

/**
 * Registro de domínio: valor anual cobrado em 1x.
 * Não divide por 12 e não recebe sufixo /mês.
 */
export function isOneTimeRegistryDomainPrice(
  productUuid?: string | null,
  alternateUuid?: string | null
): boolean {
  return (
    isRegistryDomainProductUuid(productUuid) ||
    isRegistryDomainProductUuid(alternateUuid)
  );
}

export function isRegistryDomainCartPlanOrProduct(
  planId: string | null | undefined,
  productId?: string | null
): boolean {
  return (
    isRegistryDomainVariationUuid(planId) || isRegistryDomainProductUuid(productId)
  );
}
